import ProfCaseDetailsContent from 'Components/Professional/Cases/ProfCaseDetailsContent'
import { caseDetailsProfApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import { useNavigate } from 'react-router-dom';
import NoCaseFoundModal from './NoCaseFoundModal';
import CaseValueDisp from 'Components/Professional/Cases/CaseValueDisp';
import useIsMobile from 'Hooks/useIsMobile';

function TestModal({attorney, setRefreshList = () => {}, setSingleCase, uploadNew, onClose, setCloseMsg = () => {}, caseData, caseId, setUpdateComp = () => {}, caseNumber}) {
  const {makeApiCallFunc, userDetails, setReqRevCountArr, reqRevCountArr} = useContext(Context);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const isMobile = useIsMobile();
  const userInfo = attorney ? attorney.userId : userDetails;
  const navigate = useNavigate();
  const [caseDetailsModalData, setCaseDetailsModalData] = useState(caseData)
  const [isResponseReceived, setIsResponseReceived] = useState(false);
  useEffect(() => {
    if(caseId)
    {
      updateCaseResponse(caseId)
    }
    else
    {
      setIsResponseReceived(true);
    }
  },[caseId])
  const updateCaseResponse = (id) => {
    // const l = (setUpdateComp ? setUpdateComp(prev => !prev) : '');
    console.log(id)
    makeApiCallFunc(caseDetailsProfApi, 
      {
          caseId: id ? id : caseData?.caseId,
          userId: userInfo?._id,
          isNotActiveUser: !userInfo?.isActiveSubscription
      },
    ({data})=>
    {
      setIsResponseReceived(true);
      if(data?.errorType)
      {
        switch(data.errorType)
        {
          case "reported" :
            setErrorMsg( caseNumber + " - This case has been reported by you. So you cannot view this case anymore");
            setShowErrorModal(true);
            return;
          case "conflict" :
            setErrorMsg( caseNumber + " - This case has been marked as conflict by you. So you cannot view this case anymore");
            setShowErrorModal(true);
            return;
            case "deleted" :
              setErrorMsg( caseNumber + " - This case has been deleted. So you cannot view this case anymore");
              setShowErrorModal(true);
              return;
            case "closed" :
              setErrorMsg( caseNumber + " - This case has been closed. So you cannot view this case anymore");
              setShowErrorModal(true);
              return;
            case "sos":
              setErrorMsg( caseNumber + " - The case you are trying to view is an SOS case that is available only if you have an active subscription. Please subscribe to view this case.");
              setShowErrorModal(true);
              return;
              case "justPosted":
                setErrorMsg( caseNumber + " - The case you are trying to view was posted before 30 days which is available only if you have an active subscription. Please subscribe to view this case.");
                setShowErrorModal(true);
                return;
          default:
            return;
        }
      }
      setCaseDetailsModalData(data?.[0]);  
    },
    function (error) {
        setIsResponseReceived(true);
        console.log(error);
    }
  );
  makeApiCallFunc(caseDetailsProfApi, 
    {
        caseId: id ? id : caseData?.caseId,
        userId: userInfo?._id,
        loadReqRev: true,
        isNotActiveUser: !userInfo?.isActiveSubscription

    },
  ({data})=>
  {
    let revCount = {};
    let idVal = id ? id : caseData?.caseId;
    console.log("testmodal", idVal)
    data.map(d => {
      let newObj = {
        [d._id] : d.count
      }
      return revCount = {...revCount, ...newObj}
    })
    console.log("req to close rev count data test modal", {[idVal]: revCount});
    setReqRevCountArr({[idVal]: revCount});  
  },
  function (error) {
      console.log(error);
  }
);
  }
 
  return (
    <>
    {
           
    isResponseReceived &&
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={() => onClose()}
    isOpen = {uploadNew}
    style={{
        overlay: {
            zIndex: 30
          
        },
        content: {
            height: 'auto',
            width: 'auto',
            maxHeight: isMobile? '100%' : '-webkit-calc(100% - 140px)',
            maxWidth: isMobile? '100%' : '-webkit-calc(100% - 240px)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: "2px 3px 10px #9E9E9E",
            backgroundColor: "#ffff",
            padding: isMobile ? "10px" : "20px",
        }
      }}
    >    
        <div className='flex items-center flex-col '>
       { showErrorModal ?
            <div className='flex items-center flex-col'>
            <div className='text-left text-sm text-red-700 flex text-center font-bold w-[320px] lg:w-[400px]'>
              {errorMsg ? errorMsg : "No case found with this  Case ID."}
             </div>
                <div 
                className=" shadow-xl px-4 text-sm  w-max px-2 h-8 bg-green-600 hover:bg-green-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
                onClick={onClose}>Ok</div>
            </div>
          :
        <>
        
        { !setUpdateComp && 

          <div className='w-full cursor-pointer mb-4 pb-2 flex justify-between  text-sky-600 items-center  border-b' onClick={onClose}>
          
              <div className='text-sky-600 flex justify-left items-center font-bold '>
                {caseNumber ? caseNumber : caseDetailsModalData?.caseDetails?.caseNumber} &nbsp; - 
                 <div className='ml-4'> 
                  <CaseValueDisp
              userInfo={userInfo}
              detail={caseDetailsModalData?.caseDetails}
              /></div>
              </div>
              <div className='text-xs underline'>
              Back  -&gt;
              </div>

          </div>}
         <ProfCaseDetailsContent attorney={attorney}
         setCloseMsg={setCloseMsg}
         setRefreshList={setRefreshList}
         setSingleCase={setSingleCase} 
         setCaseDetailsModalData={setCaseDetailsModalData}
         caseData={caseDetailsModalData} onClose={onClose}
         updateCaseResponse={updateCaseResponse}
         setUpdateComp={setUpdateComp} />
         </>
        }
         </div>
    </ReactModal>
  }
    </>
  )
}

export default TestModal